module.exports = __webpack_public_path__ + "img/70.6644a260.png";